// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"8df744f0","227":"57bc8cf9","298":"bc92c82f","354":"518ec7b6","468":"894801ea","735":"9f8abaa1","901":"f1ad4b4f"}[chunkId] + ".chunk.js";
};